import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
const SideMenu = () => {
        const location = useLocation();

        const [activeMenuItem, setActiveMenuItem] = useState(location.pathname);

        const handleMenuItemClick = (menuItemUrl) => {
          setActiveMenuItem(menuItemUrl);
      };
      
  const menuItems = [
    {
      name: "Profile",
      url: "/me/profile",
      icon: "fas fa-user",
    },
    {
      name: "Update Profile",
      url: "/me/update_profile",
      icon: "fas fa-user",
    },
    {
      name: "Upload Avatar",
      url: "/me/upload_avatar",
      icon: "fas fa-user-circle",
    },
    {
      name: "Update Password",
      url: "/me/update_password",
      icon: "fas fa-lock",
    },
      ];
      
      return (
        <div className="mt-8 pl-4 sm:pl-2">
          {menuItems?.map((menuItem, index) => (
            <Link
              key={index}
              to={menuItem.url}
              className={`font-bold py-2 px-3 block text-left ${
                activeMenuItem.includes(menuItem.url)
                  ? "bg-blue-500 text-white"
                  : "bg-white text-gray-900"
              } hover:bg-blue-600 hover:border-blue-500 rounded-md transition-colors duration-200 ease-in-out sm:px-2 sm:py-1.5`}
              onClick={() => handleMenuItemClick(menuItem.url)}
              aria-current={
                activeMenuItem.includes(menuItem.url) ? "true" : "false"
              }
            >
              <i className={`${menuItem.icon} mr-2 sm:mr-1`}></i>{" "}
              {menuItem.name}
            </Link>
          ))}
        </div>
      );
};

export default SideMenu;
        